var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',_vm._b({attrs:{"placeholder":_vm.placeholder,"label":_vm.label,"value":_vm.formattedValue,"outlined":_vm.outlined,"rules":_vm.fieldRules},on:{"input":_vm.updateValue}},'v-text-field',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }